import Spinner from "components/General-UI/Spinner";
import Avatar from "components/Home/ui/Avatar";
import { loadAudioSounds } from "helpers/sounds";
import React from "react";
import { useSelector } from "react-redux";
import { selectCurrentUserAttributes } from "slices/authSlice";
import { joinSpace, selectSpaceNode } from "slices/spaceSlice";

const EnterButtonContainer = ({ currentActiveEffice, enterButtonLoading }) => {
  const me = useSelector(selectCurrentUserAttributes);
  const spaceName = useSelector((state) => selectSpaceNode(state)?.content);

  return (
    <button
      className={`enter-button`}
      onClick={() => {
        loadAudioSounds();
        joinSpace(currentActiveEffice.id);
      }}
      disabled={enterButtonLoading}
    >
      {enterButtonLoading ? (
        <div className="enter-button-loader">
          <Spinner immediateShow={true} />
        </div>
      ) : (
        <div className={`action-container`}>
          <p className="no-select">{spaceName ? "move here" : "go in"}</p>
          <div className={`my-mini-avatar`}>
            <Avatar
              avatar_key={me.avatar_key}
              given_name={me.given_name}
              family_name={me.family_name}
            />
          </div>
        </div>
      )}
    </button>
  );
};

export default EnterButtonContainer;
